import React, { useEffect, useRef } from "react";
import banner2 from "../assets/images/section2-2.png";
import banner3 from "../assets/images/section2-3.png";
import json1 from "../assets/icon-01.json";
import json2 from "../assets/icon-02.json";
import json3 from "../assets/icon-03.json";

import '@lottiefiles/lottie-player';  // Import the lottie-player web component

const Cards = () => {

  return (
    <div className="cardsContainer">
      {/* First Card */}
      <div className="card">
      <lottie-player
        // ref={lottieRef}
        src={json1}  // Pass the path of the JSON file here
        autoplay  // Autoplay the animation when loaded
        loop={true}  // Set loop to false by default
        className="cardIcon"
        ></lottie-player>

        {/* <Lottie
          animationData={json1}
          play={false}
          loop={false}
          style={{ width: "100px", height: "100px" }}
        /> */}
        <p>
          <span>Flexible Capacity</span>
          <br />
          ظرفیت داخلی 900 لیتری
        </p>
      </div>

      {/* Second Card */}
      <div className="card">
      <lottie-player
        // ref={lottieRef}
        src={json2}  // Pass the path of the JSON file here
        autoplay  // Autoplay the animation when loaded
        loop={true}  // Set loop to false by default
        className="cardIcon"
        ></lottie-player>
        {/* <Lottie
          animationData={json2}
          play={false}
          loop={false}
          style={{ width: "100px", height: "100px" }}
        /> */}
        <p>
          <span>Super Freeze</span>
          <br />
          انجماد سریع مواد غذایی
        </p>
      </div>

      {/* Third Card */}
      <div className="card">
      <lottie-player
        // ref={lottieRef}
        src={json3}  // Pass the path of the JSON file here
        autoplay  // Autoplay the animation when loaded
        loop={true}  // Set loop to false by default
        className="cardIcon"
        ></lottie-player>
        {/* <Lottie
          animationData={json3}
          play={false}
          loop={false}
          style={{ width: "100px", height: "100px" }}
        /> */}
        <p>
          <span>A+ Energy Grade</span>
          <br />
          صرفه جویی در مصرف انرژی
        </p>
      </div>
    </div>
  );
};

export default Cards;
